var $d6d95ebdf4ba4134$exports = {};
$d6d95ebdf4ba4134$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kr\u{101}su atlas\u{12B}t\u{101}js`,
    "colorSwatch": `kr\u{101}su paraugs`,
    "transparent": `caursp\u{12B}d\u{12B}gs`,
    "twoDimensionalSlider": `2D sl\u{12B}dnis`
};


export {$d6d95ebdf4ba4134$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
